import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customSelectStyle } from '../../../util/selectStyles';
import ButtonMC from '../../../presentation/components/ButtonMC';
import IconMC from '../../../presentation/components/IconMC';

const primarySelectStyle = {
  ...customSelectStyle,
  placeholder: (provided) => ({
    ...provided,
    color: '#3CAAE1',
    fontSize: '12px'
  })
};

const KeyValuesApi = ({
  data = [],
  setData,
  variables,
  type,
  errors
}) => {
  const { t } = useTranslation();

  const handleKeyChange = (index, value) => {
    const newData = [...data];
    newData[index].key = value;
    setData(newData);
  };

  const handleValueChange = (index, value) => {
    const newData = [...data];
    newData[index].value = value;
    setData(newData);
  };

  const handleRemove = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const handleAddNew = () => {
    setData([...data, { key: '', value: '' }]);
  };

  return (
    <div className="key-values-container mt-8">
      {data.map((item, index) => (
        <div key={index} className="border-gray border-12 py-8 px-12 mb-24">
          <div className="d-flex justify-content-between align-items-center mb-8">
            <span className="ff-poppins-semibold">
              {t(`chatbots.options.api.header.${type}`)}
              {' '}
              {index + 1}
            </span>
            {!(type === 'headers' && index === 0) && (
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className="btn pr-0"
            >
              <IconMC name="trash-2-outline" size="xl" />
            </button>
            )}
          </div>

          <div>
            {/* Input para la clave */}
            <div className="figma-field">
              <label>{t('chatbots.options.api.object.key')}</label>
              {errors?.[type]?.[index]?.key && (
              <span className="ml-10 error-msg fz-12">{errors[type][index].key}</span>
              )}
              <input
                value={item.key}
                onChange={(e) => handleKeyChange(index, e.target.value)}
                className="input"
                placeholder={`${t('chatbots.options.api.object.example')}: ${type === 'content' ? 'message' : 'Authorization'}`}
                disabled={type === 'headers' && index === 0}
              />
            </div>

            {/* Input/Select para el valor */}
            <div className="figma-field">
              <label>{t('chatbots.options.api.object.value')}</label>
              {errors?.[type]?.[index]?.value && (
              <span className="ml-10 error-msg fz-12">{errors[type][index].value}</span>
              )}
              <div className="value-input-container">
                <input
                  value={item.value}
                  onChange={(e) => handleValueChange(index, e.target.value)}
                  className="input"
                  placeholder={`${t('chatbots.options.api.object.example')}: ${type === 'content' ? 'Hola mundo' : 'Bearer token'}`}
                  disabled={type === 'headers' && index === 0}
                />
                {!(type === 'headers' && index === 0) && (
                <div className="variables-dropdown mt-8">
                  <Select
                    options={variables}
                    placeholder={t('chatbots.options.api.object.variable')}
                    styles={primarySelectStyle}
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        handleValueChange(index, selectedOption.value);
                      }
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: () => null
                    }}
                    value={null}
                  />
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      <ButtonMC
        text={`${t('chatbots.options.api.object.add')} ${type === 'content' ? t('chatbots.options.api.object.content') : 'header'}`}
        icon="plus-outline"
        iconPosition="left"
        variant="SECONDARY"
        outlined
        size="small"
        className="tw-w-full"
        onClick={handleAddNew}
      />

    </div>
  );
};

export default KeyValuesApi;
